import Loading from 'components/Loading';
import { HeaderBar } from 'components/Header/HeaderMenu';
import Page404 from 'pages/Error';
import CM88Page from 'pages/Home';
import AffCupSchedule from 'pages/Home/AffCupSchedule';
import PrizeStructure from 'pages/Home/prizeStructure';
import RuleFixPage from 'pages/Home/rule_fix';
import WorldCupShedule from 'pages/Home/WorldCupShedule';
import { Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import favicon from './assets/images/favicon.ico';
import { SITE } from './config/config';

const favicons = {
  ok9: favicon
};

function Apps() {
  useEffect(() => {
    const faviconElement =
      document.querySelector("link[rel*='icon']") || document.createElement('link');
    faviconElement.type = 'image/png';
    faviconElement.rel = 'icon';
    faviconElement.href = favicons[SITE];
  }, []);

  return (
    <RecoilRoot>
      <BrowserRouter>
        <div className="app-shell">
          <div className="app-mobile">
            <HeaderBar />
            <div className="app-content">
              <Suspense fallback={<Loading />}>
                <Routes>
                  <Route exact path="/" element={<CM88Page />} />
                  <Route path="/rule" element={<RuleFixPage />} />
                  <Route path="/prize-structure" element={<PrizeStructure />} />
                  <Route path="/world-cup-schedule" element={<WorldCupShedule />} />
                  {/* <Route path="/aff-cup-2026" element={<AffCupSchedule />} /> */}
                  {/* Add other routes here */}
                  <Route path="*" element={<Page404 />} />
                </Routes>
              </Suspense>
            </div>
          </div>
        </div>
      </BrowserRouter>
    </RecoilRoot>
  );
}

export default Apps;
